import { Component, Input, ViewEncapsulation,OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NavService, Menu } from '../../services/nav.service';
import { NavSellerService, MenuSeller } from '../../services/navSeller.service';
import { HttpClient ,HttpHeaders,HttpErrorResponse  } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {

  public menuItems: Menu[] | any;
  public menuItemsSeller: MenuSeller[] | any;
  
  public url: any;
  public fileurl: any;
  userName:any;
  userType:any;
  seller_id:any;
  company_po_id:any;
  logo:any;
  cdn_url:any;
  
  headers = new HttpHeaders({ 'Content-Type': 'application/json','API_KEY':'20e20m06i16e14r31p','Version':'1.0' });    	 
	options = { headers: this.headers };	
	username:any;
	password:any;
	token:any;
	opt:any;
  
  ngOnInit() {
	  
	  this.userName=localStorage.getItem('userName');	
	this.userType=localStorage.getItem('userType');	
	this.seller_id=localStorage.getItem('seller_id');	
	this.company_po_id=localStorage.getItem('company_po_id');	
	this.cdn_url=environment.cdn_url_home;
	
	
	this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.options).subscribe((response) => 
	{
		this.token=response;
		//alert(this.token.access_token);
		let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
		let o = { headers: h };
	
		this.http.get(environment.api_url+'/v1/companyPO/'+this.company_po_id,o).subscribe((res) => 
		{
								
			this.logo=this.cdn_url+"/"+this.company_po_id+"/"+res[0].logo_upload;			
			
			//alert(this.logo);
			
		});	
	});	
	
	if(this.seller_id!=null && this.userType=="Location")
	{
		/*if(this.company_po_id!='')
		{
			alert("Please Logout Seller Login");
			this.router.navigate(['/auth/login']);
		}*/
		
		this.navSellerServices.items.subscribe(menuItemsSeller => {
			  this.menuItemsSeller = menuItemsSeller
			  this.router.events.subscribe((event) => {
				if (event instanceof NavigationEnd) {
				  menuItemsSeller.filter(items => {
					if (items.path === event.url)
					  this.setNavActive(items)
					if (!items.children) return false
					items.children.filter(subItems => {
					  if (subItems.path === event.url)
						this.setNavActive(subItems)
					  if (!subItems.children) return false
					  subItems.children.filter(subSubItems => {
						if (subSubItems.path === event.url)
						  this.setNavActive(subSubItems)
					  })
					  return
					})
					return
				  }
				  )
				}
			  })
			})
	}
	
	
	if(this.company_po_id!=null && this.userType=="Admin")
	{			
		/*if(this.company_po_id!='')
		{
			alert("Please Logout Seller Login");
			this.router.navigate(['/auth/login']);
		}*/
		
		this.navServices.items.subscribe(menuItems => { 
			  this.menuItems = menuItems
			  this.router.events.subscribe((event) => {
				if (event instanceof NavigationEnd) {
				  menuItems.filter(items => {
					if (items.path === event.url)
					  this.setNavActiveAdmin(items)
					if (!items.children) return false
					items.children.filter(subItems => {
					  if (subItems.path === event.url)
						this.setNavActiveAdmin(subItems)
					  if (!subItems.children) return false
					  subItems.children.filter(subSubItems => {
						if (subSubItems.path === event.url)
						  this.setNavActiveAdmin(subSubItems)
					  })
					  return
					})
					return
				  }
				  )
				}
			  })
			})
	}
	  
  }


  constructor(private router: Router, public navServices: NavService,public navSellerServices: NavSellerService,private http: HttpClient) 
  {
	
	
    
  }

  // Active Nave state
  setNavActive(item:any) {
    this.menuItemsSeller.filter((menuItem:any) => {
      if (menuItem != item)
        menuItem.active = false
      if (menuItem.children && menuItem.children.includes(item))
        menuItem.active = true
      if (menuItem.children) {
        menuItem.children.filter((submenuItems:any) => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true
            submenuItems.active = true
          }
        })
      }
    })
  }
  
  
  // Active Nave state Admin
  setNavActiveAdmin(item:any) {
    this.menuItems.filter((menuItem:any) => {
      if (menuItem != item)
        menuItem.active = false
      if (menuItem.children && menuItem.children.includes(item))
        menuItem.active = true
      if (menuItem.children) {
        menuItem.children.filter((submenuItems:any) => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true
            submenuItems.active = true
          }
        })
      }
    })
  }

  // Click Toggle menu
  toggletNavActiveAdmin(item:any) {
    if (!item.active) {
      this.menuItems.forEach((a:any) => {
        if (this.menuItems.includes(item))
          a.active = false
        if (!a.children) return false
        a.children.forEach((b:any) => {
          if (a.children.includes(item)) {
            b.active = false
          }
        })
        return
      });
    }
    item.active = !item.active
  }
  
  
  // Click Toggle menu
  toggletNavActive(item:any) {
    if (!item.active) {
      this.menuItemsSeller.forEach((a:any) => {
        if (this.menuItemsSeller.includes(item))
          a.active = false
        if (!a.children) return false
        a.children.forEach((b:any) => {
          if (a.children.includes(item)) {
            b.active = false
          }
        })
        return
      });
    }
    item.active = !item.active
  }

  //Fileupload
  readUrl(event: any) {
    if (event.target.files.length === 0)
      return;
    //Image upload validation
    var mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    // Image upload
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.url = reader.result;
    }
  }

  

}
